import { render } from "./OrdersChart.vue?vue&type=template&id=9a9d564c"
import script from "./OrdersChart.vue?vue&type=script&lang=js"
export * from "./OrdersChart.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__